import React, { PureComponent } from 'react';
import _ from 'lodash';
import queryString from 'query-string';
import { Select, Radio, Input, Button, Collapse } from 'antd';
import { withRouter } from 'react-router-dom';
import { Image } from '../../components';
import { withRedux } from '../../hoc';
import { getServiceUrl } from '../../utils';

const Option = Select.Option;
const Panel = Collapse.Panel;
const Search = Input.Search;

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    product: _.get(state, 'product')
  };
};

const actions = {};

@withRouter
@withRedux(mapStateToProps, actions)
export default class Main extends PureComponent {
  constructor(props) {
    super(props);
    this.searchInputRef = React.createRef();
    this.searchInputMobileRef = React.createRef();
    this.brandRef = React.createRef();
    this.categoryRef = React.createRef();
  }
  state = {
    searchBrand: undefined,
    searchCategory: undefined,
    collapseFilterMobile: ''
  };
  handleSelectBrand = value => {
    if (this.state.searchBrand !== value) {
      this.setState({ searchBrand: value });
    }
  };
  handleSelectCategory = value => {
    if (this.state.searchCategory !== value) {
      this.setState({ searchCategory: value });
    }
  };
  search = searchValue => {
    const { searchBrand, searchCategory } = this.state;
    if (searchBrand || searchCategory || searchValue) {
      this.handleOnChangeCollapseFiltersMobile();
      const params = {
        brand: searchBrand,
        category: searchCategory,
        q: searchValue
      };
      const stringified = queryString.stringify(params);
      this.props.history.push({
        pathname: '/product',
        search: `?${stringified}`
      });
    }
  };
  handleSearch = e => {
    e.preventDefault();
    const searchValue = this.searchInputRef.current.input.value;
    this.search(searchValue);
  };
  handleOnSearchMobile = value => {
    this.search(value);
  };
  handleSelectBrandMobile = value => {
    this.handleSelectBrand(value);
  };
  handleSelectCategoryMobile = value => {
    this.handleSelectCategory(value);
  };
  handleClickSearchMobile = () => {
    const searchValue = this.searchInputMobileRef.current.input.input.value;
    this.search(searchValue);
  };
  handleOnChangeCollapseFiltersMobile = (key = '') => {
    const value = this.state.collapseFilterMobile === '' ? key : '';
    this.setState({ collapseFilterMobile: value });
  };
  renderDesktopMode = () => {
    const { searchBrand, searchCategory } = this.state;
    const { t } = this.props;
    const brands = _.get(this.props, 'product.brands.data');
    const categories = _.get(this.props, 'product.categories.data');
    return (
      <div className="main-block">
        <div className="container">
          <form className="search-form" onSubmit={this.handleSearch}>
            <div className="search-group">
              <div className="brand">
                <Select
                  value={searchBrand}
                  placeholder={t('Brands')}
                  getPopupContainer={() => this.brandRef.current}
                  onChange={this.handleSelectBrand}
                >
                  {_.map(brands, brand => {
                    const { id, name, logo } = brand;
                    const full_file_path = `${getServiceUrl()}/${_.get(logo, 'path')}`;
                    return (
                      <Option key={id} value={id}>
                        <Radio checked={searchBrand === id}>
                          <Image src={full_file_path} alt={t(name)} />
                        </Radio>
                      </Option>
                    );
                  })}
                </Select>
                <div className="for-dropdown" ref={this.brandRef} />
              </div>
              <div className="category">
                <Select
                  value={searchCategory}
                  placeholder={t('Categories')}
                  getPopupContainer={() => this.categoryRef.current}
                  onChange={this.handleSelectCategory}
                >
                  {_.map(categories, category => {
                    const { id, name } = category;
                    return (
                      <Option key={id} value={id}>
                        <Radio checked={searchCategory === id}>{t(name)}</Radio>
                      </Option>
                    );
                  })}
                </Select>
                <div className="for-dropdown" ref={this.categoryRef} />
              </div>
              <div className="input">
                <Input ref={this.searchInputRef} placeholder={t('Search Code e.g.SKR20')} />
              </div>
            </div>
            <div className="search-btn">
              <Button htmlType="submit" icon="search">
                {t('Search')}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  };
  renderMobileMode = () => {
    const { searchBrand, searchCategory, collapseFilterMobile } = this.state;
    const { t } = this.props;
    const brands = _.get(this.props, 'product.brands.data');
    const categories = _.get(this.props, 'product.categories.data');
    return (
      <div className="main-block">
        <div className="search-input">
          <Search
            ref={this.searchInputMobileRef}
            placeholder={t('Search Code e.g.SKR20')}
            onSearch={value => this.handleOnSearchMobile(value)}
            enterButton
          />
        </div>
        <div className="filters">
          <Collapse activeKey={collapseFilterMobile} onChange={this.handleOnChangeCollapseFiltersMobile}>
            <Panel header={t('Filters')} key="filters">
              <Collapse defaultActiveKey={['brands', 'categories']}>
                <Panel header={t('Brands')} key="brands">
                  <ul className="brands">
                    {_.map(brands, brand => {
                      const { id, name } = brand;
                      const activeClass = searchBrand === id ? 'active' : '';
                      return (
                        <li key={id} className={`item ${activeClass}`} onClick={() => this.handleSelectBrandMobile(id)}>
                          {t(name)}
                        </li>
                      );
                    })}
                  </ul>
                </Panel>
                <Panel header={t('Categories')} key="categories">
                  <ul className="categories">
                    {_.map(categories, category => {
                      const { id, name } = category;
                      const activeClass = searchCategory === id ? 'active' : '';
                      return (
                        <li
                          key={id}
                          className={`item ${activeClass}`}
                          onClick={() => this.handleSelectCategoryMobile(id)}
                        >
                          {t(name)}
                        </li>
                      );
                    })}
                  </ul>
                </Panel>
                <div className="search-btn">
                  <Button onClick={this.handleClickSearchMobile}>{t('Search')}</Button>
                </div>
              </Collapse>
            </Panel>
          </Collapse>
        </div>
      </div>
    );
  };
  render() {
    return (
      <div className="search-component main">
        <div className="mobile-mode">{this.renderMobileMode()}</div>
        <div className="desktop-mode">{this.renderDesktopMode()}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Search/Main.js